import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Internal dependencies
 */

const ToolbarButtonContainer = ({
  children,
  className
}) => /*#__PURE__*/_jsx("div", {
  className: className,
  children: children
});
export default ToolbarButtonContainer;